import API_ENDPOINTS from "../../apis/endpoints";

export const handleLogout = async (access_token) => {
    const storedDeviceId = localStorage.getItem("device-id");

    try {
        await fetch(`${API_ENDPOINTS.LOGOUT}`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${access_token}`,
                "x-cc-device-id": storedDeviceId,
                "ngrok-skip-browser-warning": "true",
            },
        });
    } catch (error) {
        console.error("Error calling logout API:", error);
        alert("An error occurred during logout. Please try again.");
    }
};
